module.exports = __webpack_public_path__ + "img/材料力学5_4.2eb72054.jpg";